import React, { useState } from 'react'
import { ReactComponent as Star } from '../../../assets/icon/classreview-star.svg'
import Save from '../../../assets/icon/classreview-save.svg'
import Info from '../../../assets/icon/classreview-info.svg'
import Checkbox from 'components/Input/Checkbox'
import { useDispatch, useSelector } from 'react-redux'
import { submitClassReview } from '../../../routing/fetchingfunction/classBannerBooking/classBannerBooking.actions'
import { selectErrorsubmitClassReview } from '../../../routing/fetchingfunction/classBannerBooking/classBannerBooking.reducer'
import ErrorMessageWithExclamation from 'components/UI/ErrorMessageWithExclamation'
import ThanksModal from '../Modals/ThanksModal'

const initialReview = {
  rating_patience: 1,
  rating_flexibility: 1,
  rating_empathy: 1,
  rating_communication: 1,
  rating_knowledge: 1,
}
const reviewLabels = {
  rating_patience: 'Patience',
  rating_flexibility: 'Flexibility',
  rating_empathy: 'Empathy',
  rating_communication: 'Communication',
  rating_knowledge: 'Knowledge',
}

const SubmitButton = ({ bg, text, onClick }) => {
  const [isLoading, setIsLoading] = useState(false)

  const handleClick = async () => {
    setIsLoading(true)
    await onClick()
    setIsLoading(false)
  }

  return (
    <button
      onClick={handleClick}
      className={`w-[200px] h-[44px] rounded-md flex justify-center items-center text-white bg-[${bg}] cursor-pointer`}
      disabled={isLoading}
    >
      {isLoading ? 'loading...' : text}
    </button>
  )
}

const ClassReview = () => {
  const [review, setReview] = useState(initialReview)
  const [hoveredIndex, setHoveredIndex] = useState({})
  const [bookAgain, setBookAgain] = useState(true)
  const [comments, setComments] = useState('')
  const [successModal, setSuccessModal] = useState(false)
  const error = useSelector(selectErrorsubmitClassReview)

  const dispatch = useDispatch()

  const handleStarHover = (key, index) => {
    setHoveredIndex((prev) => ({ ...prev, [key]: index }))
  }

  const handleStarClick = (key, index) => {
    const updatedReview = { ...review }
    updatedReview[key] = index + 1
    setReview(updatedReview)
  }

  const handleReviewComment = (e) => {
    setComments(e.target.value)
  }

  const handleMouseLeave = (key) => {
    setHoveredIndex((prev) => ({ ...prev, [key]: review[key] - 1 }))
  }

  const handleReviewSubmit = async () => {
    setSuccessModal(false)
    const payload = {
      ...review,
      booking: '3f3ef609946c6b3c4759',
      comments,
    }
    await dispatch(submitClassReview(payload))
    if (!error) {
      setSuccessModal(true)
    }
  }

  return (
    <div className="w-[95%] max-w-[1020px] flex flex-col items-center p-5 bg-[#FEEBDD] mx-auto my-5 rounded-lg">
      <ThanksModal isOpen={successModal} setIsOpen={setSuccessModal} />
      <div className="text-base font-normal leading-6 text-[#F67443]">Tuesday, May 22, 2023</div>
      <div className="text-2xl font-bold leading-[34px] text-[#F67443] my-2">
        Basic Class with Tira Cardhz is Finished3
      </div>
      <div className="text-base font-normal leading-6 text-[#F67443] ">
        How would you rate the tutor in this class?
      </div>
      <div className="w-[98%] max-w-[500px] bg-[#FFF5EE] border px-[3%] py-4 rounded-[10px] border-solid border-[#FFCA84] my-2 mx-auto">
        {Object.entries(review).map(function (entry) {
          const [key, value] = entry
          return (
            <div className="w-full flex justify-between items-center my-2 flex-wrap" key={key}>
              <div className="text-base font-normal text-[#F67443] capitalize my-1">
                {reviewLabels[key]}
              </div>
              <div className="flex items-center">
                {[...Array(5)].map((_, index) => (
                  <div
                    key={index}
                    className="mx-1 cursor-pointer"
                    onMouseEnter={() => handleStarHover(key, index)}
                    onMouseLeave={() => handleMouseLeave(key)}
                    onClick={() => handleStarClick(key, index)}
                  >
                    <Star fill={index < value ? '#FFC700' : '#E6BDA0'} />
                  </div>
                ))}
              </div>
            </div>
          )
        })}
      </div>
      <div className="my-2 text-base font-normal text-[#F67443]">
        Please leave your review for your tutor (Optional)
      </div>
      <textarea
        onChange={handleReviewComment}
        className="placeholder-[#F67443] text-[#F67443] border bg-[#FFDEC7] w-full  max-w-[500px] min-h-[148px] text-base pb-5 p-3 rounded-[10px] outline-none border-solid border-[#F79009]"
        placeholder="Write a review..."
      ></textarea>

      <div className="flex items-center my-3">
        <button className="flex items-center bg-[#F79009] text-white rounded-md px-3 py-2 mr-2 cursor-pointer text-base font-bold">
          <img src={Save} alt="" />
          <span className="ml-2">Save class recording</span>
        </button>

        <div className="relative group">
          <img src={Info} alt="info" className="ml-1.5 cursor-pointer" />
          <div className="absolute hidden  group-hover:block z-10 w-[95vw] max-w-[400px] p-4 rounded-lg bg-white shadow-[0px_8px_16px_0px_#00000040] border border-solid border-[#F79009]">
            <p className="text-[#F67443] text-sm font-normal leading-5">
              The class will be automatically saved to attachments, where it can be downloaded or
              sent to cloud (max limit: 1 GB).
              <br />
              <br />
              If your data limit is reached, you can download it directly to your computer, or send
              the file to your cloud storage.
            </p>
          </div>
        </div>
      </div>

      <div className="my-4 border-b border-b-[#FFCA84]  border-solid w-full"></div>

      <div className="flex w-full justify-between items-center flex-wrap">
        <div className="w-full min-h-[330px] min-w-[300px] max-w-[430px] bg-green-200 text-[#1AC057] flex flex-col items-center p-5 rounded-[10px]">
          <div className="text-2xl font-bold mb-4">Approve the Class</div>
          <div className="text-base text-center mb-4">
            Approving the class means that everything is okay. You agree that tutor showed their
            professional skills and the class went well.
          </div>
          <SubmitButton bg="#1AC057" text="Approve" onClick={handleReviewSubmit} />
          <div className="w-full mt-4">
            <Checkbox
              label={`Book class with Tira Chardz again`}
              labelClassName="text-base font-bold"
              checked={bookAgain}
              onChange={() => setBookAgain(!bookAgain)}
            />
          </div>
        </div>
        <div className="w-full min-h-[330px] min-w-[300px] max-w-[430px] bg-[#FEC8C8] text-[#EF4343] flex flex-col items-center p-5 rounded-[10px]">
          <div className="text-2xl font-bold mb-4">Deny the Class</div>
          <div className="text-base text-center mb-4">
            If you will deny the class, you will get your money back. Tutor will not be suggested to
            for you again. Note: You can't deny more than 3 classes in one month.
          </div>

          <SubmitButton bg="#EF4343" text="Deny" onClick={handleReviewSubmit} />
        </div>
        {error && <ErrorMessageWithExclamation text={error} className="mr-auto !mt-[12px]" />}
      </div>
    </div>
  )
}

export default ClassReview
